export const LANGUAGE_CHANGED_EVENT_TYPE = 'LANGUAGE_CHANGED';
